/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_FetchingInputs */

const cs_import_progress_phase_fetching = /** @type {(inputs: Import_Progress_Phase_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stahování`)
};

const en_import_progress_phase_fetching = /** @type {(inputs: Import_Progress_Phase_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching`)
};

/**
* | output |
* | --- |
* | "Fetching" |
*
* @param {Import_Progress_Phase_FetchingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_fetching = /** @type {((inputs?: Import_Progress_Phase_FetchingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_FetchingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_fetching(inputs)
	return cs_import_progress_phase_fetching(inputs)
});